const linkCls = "vyjljdbzbm";
const labelCls = "vyjl1ahncgf";
const rightContainerCls = "vyjr1hs26mo";
const countCls = "vyjckxlqlo";
const chevronCls = "vyjc1k7yhcd";

export { chevronCls, countCls, labelCls, linkCls, rightContainerCls };
import "./atom.go-to-search-item.style.linaria.module.css";
//# sourceMappingURL=atom.go-to-search-item.style.js.map
